var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 290 290",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(-1,1) translate(-290, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.6242 264.4432c9.9538 0 17.3222-7.3684 17.3222-17.193v-46.6666h3.2318c47.4423 0 76.5282 13.7026 97.0822 51.9667 5.0415 9.3075 11.3758 11.3758 17.9686 11.3758 8.9197 0 15.771-8.2733 15.771-24.1736 0-93.8504-41.2373-151.505-130.8218-151.505h-3.2318V41.9686c0-9.9538-7.3684-17.9686-17.5807-17.9686-6.8514 0-11.6344 2.844-19.0028 9.6953l-102.5116 95.531C6.8098 134.0092 5 139.3092 5 144.2215c0 4.6537 1.939 10.2124 6.9806 14.9954l102.3823 96.1773c6.722 6.205 12.2807 9.049 19.2613 9.049zm-8.144-32.8347c-.7757 0-1.422-.3878-2.1977-1.0342L34.603 146.6777c-1.0342-1.0341-1.2928-1.6805-1.2928-2.456 0-.7757.2586-1.422 1.2928-2.4562l88.6795-84.6722c.6464-.6464 1.2928-1.0342 2.1976-1.0342 1.0342 0 1.9391.7756 1.9391 1.939v48.9936c0 2.9732 1.2927 4.266 4.266 4.266h16.5466c84.0258 0 112.8531 55.8448 115.0507 117.2483 0 .9049-.3878 1.2927-.9048 1.2927-.6464 0-.905-.3878-1.2928-1.1634-15.3831-32.3177-53.3887-51.3204-112.8531-51.3204H131.685c-2.9732 0-4.2659 1.2927-4.2659 4.2659v47.9594c0 1.1634-.7756 2.0683-1.939 2.0683z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.27c02c4487c9711aaab1be4b134bf74d.svg";
export { ForwardRef as ReactComponent };